import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { ContainerWrapper, FlexEnd, HrefCTA, HelmetTitle } from "../../../Components/Utils";

const AddProject = styled.div`
display: flex;
padding: 0;
margin-bottom: 5px;
`;

export default class GersProjects extends React.Component {
  constructor(props) {
    super(props);
    this.state = { projects: 'Loading..'};
  }
  componentDidMount() {
    this.tikiGet('projects');
  }

  tikiGet(projects) {
    const url = "https://lms.ltwgers.com/globalProjectAPI.php";
    return fetch(url, {
      method: 'get',
      headers: new Headers({
        "secret": "XKLJLKJKLJLK83833dsklfj28923kncdnlkwej383843j3k"
      }),
    }).then(response => {
      return response.json()
    }).then(res => {
      this.setState({[projects]:res});
      console.log('From lms tiki', res);
    }).catch(error => {
      console.error("Error occured", error);
    })
  }

  render() {
  
    const pd = this.state.projects["project"] || '';
    console.log("testing..", pd);
    let ct = 0;
    return (
    <div>
      <HelmetTitle title={this.props.isPrinciple ? "GERS principles project" : "Global projects"} />
      <ContainerWrapper textAlign="justify">
        <h3>{this.props.isPrinciple ? "GERS principles project" : "Global projects"}</h3>
        {this.props.isPrinciple 
          ? <p>Contribute new GERS principles and changes in existing principles.</p> 
          : <p>Global projects develop new tools, products and services, improve existing scalecamps and design new ones, produce literature reviews, and apply tools to solve real problems – such as the application of the J-tool to market analysis.</p>
        }
        <AddProject>
          <div style={{width: "100%", alignSelf: "flex-start", justifySelf: "flex-start"}}>{!this.props.isPrinciple && <p>Global Projects include:</p>}</div>
          <FlexEnd><HrefCTA href={this.props.isPrinciple ? "https://lms.globalgers.co/item37" : "https://lms.globalgers.co/Project-list"} target="_blank" rel="noopener noreferrer" onClick={(e) => { if (!window.confirm(`You are about to open a new tab for the requested utility`)) { e.preventDefault(); return false; }} }>Contribute</HrefCTA></FlexEnd>
        </AddProject>
        <div style={{autoFlow: "auto"}}>
          <table className="table table-bordered table-striped text-left w-100">
          <thead>
          <tr>
            <th>Title</th>
            <th>Objective</th>
            <th>Lead</th>
          </tr>
          </thead>
          <tbody>
          {
            pd && pd.map(p => (
              <tr key={ct++}>
                <td className="w-20"><Link to={`/services/projects/${p.itemId.replace(/\s/g,'').toLowerCase()}`}>{p.title}</Link></td>
                <td className="w-60">{p.description}</td>
                <td className="w-20">{p.lead}</td>
              </tr>
            ))
          }
          </tbody>
          </table>
        </div>
      </ContainerWrapper>
    </div>
    );
  }
}




// WEBPACK FOOTER //
// ./src/Pages/BannerItems/Pages/GersProjects.js